module.exports = __webpack_public_path__ + "lazerBrochure.png?a6d679cf8b9ee428cccd79562f520eb5";